import { Component, OnInit, Pipe, PipeTransform, Input } from '@angular/core';
import { DynamicGridComponent } from '../../dynamic-entity/dynamic-entity.module';
import { ApiService, MetadataService, ExpressionFilter, Condition, ExpressionRule, Operator } from '../../ubi-core/ubi-core.module';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../theme/index';
import { ToastrService } from 'ngx-toastr';
import { CustomerReportsService } from './customer-reports.service';
import * as _ from 'lodash';

declare var $: any;

@Component({
  selector: 'app-customer-reports',
  templateUrl: './customer-reports.component.html',
  styleUrls: ['./customer-reports.component.scss']
})
export class CustomerReportsComponent extends DynamicGridComponent implements OnInit {
  @Input()
  hasCustomerFilter: boolean;
    
  private customers = [];
  private vessels = [];
  private customerId = null;
  private vesselAndProcessId = null;
  private gridHasData = false;
  private processing = false;
  protected result: any;

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService, protected toastr: ToastrService,
    protected customerreportsservice: CustomerReportsService) {
    super(baseservice, metadataservice, router, route, modalService, filterservice);
  }

  ngOnInit() {
    super.ngOnInit();
    const hasCustomerFilterFromRoute = this.route.snapshot.data['hasCustomerFilter'];

    if (hasCustomerFilterFromRoute != null && this.hasCustomerFilter == null) {
      this.hasCustomerFilter = hasCustomerFilterFromRoute;
    }

    if (this.hasCustomerFilter) {
      this.getCustomers();

      if (this.customerreportsservice.CustomerId != null){
        this.customerId = this.customerreportsservice.CustomerId;
        this.getVessels();
      }
    } else {
      this.getVessels();
    }

    if (this.customerreportsservice.VesselAndProcessId !== null && this.customerreportsservice.VesselAndProcessId !== undefined) {
      this.vesselAndProcessId = this.customerreportsservice.VesselAndProcessId;
      this.view();
    }
  }

  /**
   * Get data on onInit
   * This is an override
   */
  protected getInitialData() {

  }

  onCustomerChange(event) {
    this.vesselAndProcessId = null;
    this.lista = null;
    this.result = null;
    this.vessels = [];

    if (this.customerId === '') {
      this.customerId = null;
    } else {
      this.getVessels();
    }

    this.customerreportsservice.CustomerId = this.customerId;
    this.customerreportsservice.VesselAndProcessId = this.vesselAndProcessId;
  }

  onVesselChange(event) {
    if (this.vesselAndProcessId === '') {
      this.vesselAndProcessId = null;
      this.lista = null;
      this.result = null;
    } else if (!this.hasCustomerFilter || this.customerId !== '') {
      this.view();
    }

    this.customerreportsservice.VesselAndProcessId = this.vesselAndProcessId;
  }

  public view() {
    if (this.hasCustomerFilter && (this.customerId == null || isNaN(this.customerId))){
      this.toastr.warning('Deve seleccionar um cliente', '', { timeOut: 4000 });
    } else {
      const url = this.hasCustomerFilter
        ? this.entity + '/Summary?customerId=' + this.customerId + '&vesselAndProcessId=' + this.vesselAndProcessId
        : this.entity + '/Summary?vesselAndProcessId=' + this.vesselAndProcessId;
      this.baseservice.setEntity(url);
      this.baseservice.getAll().subscribe(
        data => {
          this.lista = data.Group;
          this.result = data.Data;
          this.gridHasData = data.Data.length > 0;
        },
        error => {
          console.log('Error getting list: ' + error);
          this.toastr.error('Erro a obter a lista.', '', { timeOut: 3000 });
        });
      
      this.baseservice.setEntity(this.entity);
    }
  }

  private getCustomers() {
    this.baseservice.setEntity('Customers/GetSeaportCustomers');
    this.baseservice.getPage({ 'pageSize': 100, 'sortAsString': 'Designation' }).subscribe(
      response => {
        this.customers = response.data;
      },
      error => {
        console.log('Error getting customers list: ' + error);
        this.toastr.error('Erro a obter a lista de clientes.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity(this.entity);
  }

  private getVessels() {
    const url = this.hasCustomerFilter
      ? this.entity + '/VesselAndProcesses?customerId=' + this.customerId
      : this.entity + '/VesselAndProcesses';

    this.baseservice.setEntity(url);
    this.baseservice.getAll().subscribe(
      response => {
        this.vessels = response;
      },
      error => {
        console.log('Error getting vessels list: ' + error);
        this.toastr.error('Erro a obter a lista de navios.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity(this.entity);
  }

  private getTodayDateString() {
    const today: Date = new Date();
    const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
    const month = today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
    return today.getFullYear() + '-' + month + '-' + day;
  }

  private openItemDetail(item) {
    if (this.hasCustomerFilter) {
      this.router.navigateByUrl(this.navigateUrl + '/' + this.customerId + '/' + this.vesselAndProcessId + '/' + +new Date(item.OutputDate) +
        '/' + item.SoldToID + '/' + item.ShipToID);
    } else {
      this.router.navigateByUrl(this.navigateUrl + '/' + this.vesselAndProcessId + '/' + +new Date(item.OutputDate) +
        '/' + item.SoldToID + '/' + item.ShipToID);
    }
  }

  private exportCustomersReport(format) {
    if (this.hasCustomerFilter && (this.customerId == null || isNaN(this.customerId))){
      this.toastr.warning('Deve seleccionar um cliente', '', { timeOut: 4000 });
      return;
    }

    this.processing = true;
    const extension = format === 'PDF' ? '.pdf' : '.xls';
    const request = this.hasCustomerFilter
      ? {
        'Path': 'CustomersReport',
        'Parameters': {
          'CustomerId': this.customerId,
          'VesselAndProcessId': this.vesselAndProcessId
        }
      }
      : {
        'Path': 'CustomersReport',
        'Parameters': {
          'VesselAndProcessId': this.vesselAndProcessId
        }
      };

    this.baseservice.setEntity('CustomerReports/Export' + format);
    this.baseservice.getFile(request, 'application/pdf').subscribe(
      response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response);
        link.download = 'CustomerReports' + extension;
        link.click();
        this.processing = false;
      },
      error => {
        console.log('Error getting report: ' + error);
        this.toastr.error('Erro a gerar o relatório.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/customerReports/customer-reports.component.ts